<template>
  <div class="qrcode">
    <div class="qrcode_time">二维码有效期：{{cutTime}} s</div>
    <div class="qrcode_box">
      <img v-if="qrcode_img" class="qrcode_img" :src="qrcode_img">
      <div class="qrcode_mask" v-if="cutTime==0"></div>
    </div>
    <div v-if="showBtn" @click='refreshImg' class="refresh_btn">刷新</div>
    <div v-else class="refresh_btn_defult">刷新</div>
  </div>
</template>
<script>
  var timer;
  import member from '../../api/member/memberinfo';
  import { mapState } from 'vuex';
  import { Button,Toast } from 'vant';
  export default {
    data () {
      return {
        list:[],
        qrcode_img:'',
        params:{
          h_id:0,
          type:0,
          page:1,
        },
        imgIndex:0,
        time:'',
        cutTime:'',
        refreshNum:10,
        showBtn:true
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      clearInterval(timer);
      this.params.h_id = this.$route.query.hid
      this.params.size = this.$route.query.size
      this.params.type = this.$route.query.type
      this.getImgList()
    },
    methods: {
      getImgList(){
        var that=this
        member.getImgList(that.params).then(res => {
          if(res.data.state==1){
            that.list=res.data.data.list.data
            that.qrcode_img=that.list[0].url
            that.sumNum=that.list.length
            that.refreshNum=that.sumNum-10
            that.time=res.data.data.time
            that.cutTime=res.data.data.time
            timer=setInterval(function(){
              that.cutTime=that.cutTime-1
              if(that.cutTime<1){
               that.cutTime=0
               clearInterval(timer);
             }
           },1000);  
          }
        })
      },
      refreshImg(){
        // Toast.loading({
        //   message: '加载中...',
        //   forbidClick: true,
        //   duration:100
        // });
        var that=this
        clearInterval(timer);
        that.showBtn=false
        setTimeout(function(){
          that.showBtn=true
        },1500)
        that.imgIndex=that.imgIndex+1
        that.cutTime=that.time
        
        that.qrcode_img=that.list[that.imgIndex+1].url
        timer=setInterval(function(){
          that.cutTime=that.cutTime-1
          if(that.cutTime<1){
            that.cutTime=0
            clearInterval(timer);
          }
        },1000);

        if(that.imgIndex==that.refreshNum){
          that.params.page=that.params.page+1
          member.getImgList(that.params).then(res => {
            if(res.data.state==1){
              that.list=[...that.list,...res.data.data.list.data]
              that.sumNum=that.list.length
              that.refreshNum=that.sumNum-10
            }
          })
        }
        console.log(that.imgIndex)
        console.log(that.sumNum-2)
        if(that.imgIndex==that.sumNum-2){
          that.imgIndex=0
          that.params.page=1
          that.getImgList()
        }
      }
    },
    components: {
      [Button.name]:Button,
      [Toast.name]:Toast
    }
  }
</script>
<style lang="scss">
  .qrcode{
    text-align: center;
    .qrcode_time{
      font-size: 16px;
      font-weight: bold;
      margin-top: 50px;
      color:#1F2A75;
    }
    .qrcode_box{
      position:relative;
      margin-top: 15%;
      width:100%;
      height: auto;
      .qrcode_img{
        width:100%;
        height: auto;
      }
      .qrcode_mask{
        width: 100%;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        // background-color: rgba(31, 42, 117, 0.95);
         background-color: rgba(0, 0, 0, 0.65);
         display: flex;
         align-items: center;
         justify-content: center;
         font-size: 50rpx;
         font-weight: bold;
         color: #ffffff;
         letter-spacing:2px;
         border-radius:180px;
       }
     }

     .refresh_btn{
      color: #ffffff;
      font-size: 14px;
      text-align: center;
      padding:10px 0;
      margin:0 25%;
      border-radius:5px;
      margin-top: 10%;
      background-color:#1F2A75;
    }
    .refresh_btn_defult{
      font-size: 14px;
      text-align: center;
      padding:10px 0;
      margin:0 25%;
      border-radius:5px;
      margin-top: 10%;
      background-color:#eaeaea;
    }

  }
</style>
